<template>
  <B-Modal
    id="modal-handling-pickup-error"
    body-class="!p-10 text-black w-full"
    size="lg"
    centered
    hide-footer
    hide-header
    hide-header-close
    no-close-on-esc
  >
    <button
      class="absolute top-10 right-10"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/LP-Komcard/close-circle.svg"
        alt="close"
        class="size-[30px]"
        @click="handleCloseModal"
      >
    </button>
    <img
      src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
      alt="warning-bulk-upload"
      class="size-[100px] mx-auto"
    >
    <div
      class="mt-2 text-center"
    >
      <h3 class="text-2xl font-semibold text-black">
        Proses pengajuan packing gagal
      </h3>
      <p class="font-light my-[10px] mb-[20px]">
        Yuk perbaiki pengajuan packing sesuai dengan detail error berikut:
      </p>
      <b-table
        :items="data"
        :fields="pickupErrorFields"
        class="rounded-lg"
        responsive
      />
      <div>
        <b-button
          variant="primary"
          @click="handleRetryPacking"
        >
          Perbaiki Pengajuan Packing
        </b-button>
      </div>
    </div>
  </B-Modal>
</template>

<script>
import { pickupErrorFields } from '../config'

export default {
  name: 'ModalBulkUploadStatus',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pickupErrorFields,
    }
  },
  computed: {
    thereIsInsufficientBalance() {
      return this.data.some(item => item.reason === 'insufficient_balance')
    },
    errorMessage() {
      if (this.thereIsInsufficientBalance) {
        return 'Pengajuan packing gagal karena saldomu tidak mencukupi. Yuk Top-Up saldomu sekarang untuk mengajukan packing kembali pada gudang berikut:'
      }
      return 'Silahkan ulangi pengajuan pickup untuk gudang berikut:'
    },
  },
  methods: {
    handleCloseModal() {
      this.$bvModal.hide('modal-bulk-upload-status')
      this.$nextTick(() => {
        this.$emit('close')
      })
    },
    handleTopUpSaldo() {
      this.$router.push({ name: 'saldo', params: { topup: true } })
    },
    handleRetryPacking() {
      this.handleCloseModal()
    },
  },
}
</script>
